const apiConfig = {
	// url: process.env.API_URL || 'https://grjfgat303.execute-api.us-east-1.amazonaws.com'
	// url: `https://${window.location.hostname}/api`
	url: window.location.hostname === 'localhost' ? `http://localhost:3001` : `https://${window.location.hostname}/api`
}

export default apiConfig;